<template>
  <div :class="$style.circle" :style="wrapperStyle">
    <img
      :src="src" alt="profile logo"
      :class="$style.image"
    >
  </div>
</template>

<script>
export default {
  name: 'callout-avatar',
  props: {
    source: {
      type: String
    },
    size: {
      type: Number,
      default: 56
    }
  },
  computed: {
    wrapperStyle () {
      const style = {
        width: `${this.size}px`,
        height: `${this.size}px`,
        lineHeight: `${this.size}px`,
        fontSize: `${Math.floor(this.size * 0.5)}px`
      }
      return style
    },
    src () {
      return this.source || '~@/assets/img/callout-q-white.png'
    }
  }
}
</script>

<style module lang="scss">
.circle {
  border-radius: 100%;
  color: $text-lightest;
  overflow: hidden;
  text-align: center;
}
.image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
